import { useRef, useState } from 'react';
import { imgs } from '../assets/imgs';
import { tracking } from '../utils/tracking';
import { Banner, InfoSection, VentureForm, VideoSection } from '../components';
import { useResizeImg } from '../hooks/useResizeImg';

const vidUrl = "https://www.youtube.com/embed/xZotB8v2RmM?&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=xZotB8v2RmM";
const vidHeader = "Watch the trailer for the Venture Summit";


export const VentureNurturing = () => {
   document.title = "New England Venture Summit | Venture Nurturing";
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.ventureNurturing.ventureBannerDesktop, imgs.ventureNurturing.ventureBannerMobile)
   const scrollRef = useRef(null);
   return (
      <div className='venture-nurturing'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1>Venture Nurturing</h1>
               <h2>Helping seed stage startups get where they need to be</h2>
            </section>
            <section>
               <button className="btn" onClick={() => { tracking(345); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }}>APPLY NOW</button>
            </section>
         </Banner>
         <InfoSection  img={imgs.ventureNurturing.ventureInfo}>
            <h1>Gain visibility for your startup</h1>
            <span></span>
            <p>This unique program provides 25 qualified startups free tickets to attend and network at the Venture Summit.</p>
            <p>The opportunity for Venture Nurturing startups is totally free.</p>
            <p>To qualify, your startup or the startup you nominate must meet the following criteria</p>
            <ol>
               <li>Have not raised any funding to date</li>
               <li>Have less than $100K annual revenue</li>
               <li>Have not previously attended a youngStartup Ventures conference</li>
            </ol>
            <p>Startups selected will be awarded one Startup Silver Ticket to attend the Venture Summit</p>
         </InfoSection>
         <VideoSection url={vidUrl} header={vidHeader} />
         <div ref={scrollRef} style={{ scrollMargin: '70px' }} />
         <VentureForm />
      </div>
   )
}